import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule } from '@angular/router';
import { getAppRoutes } from './routes/routes';
@NgModule({
  imports: [RouterModule.forRoot(getAppRoutes(), { preloadingStrategy: NoPreloading, canceledNavigationResolution: 'computed' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
